import { render, staticRenderFns } from "./page-login.vue?vue&type=template&id=1c522700"
import script from "./page-login.vue?vue&type=script&lang=ts"
export * from "./page-login.vue?vue&type=script&lang=ts"
import style0 from "./page-login.vue?vue&type=style&index=0&id=1c522700&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports